<div class="container my-5 p-4 mt-3 rounded-lg">
  <div class="header d-flex justify-content-between align-items-center mb-4">
    <p class="mb-0 font-weight-bold text-x">Invoice Steps Configuration</p>
    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="save_configuration">
      {{ saveButtonText }}
    </button>
  </div>

  <div class="d-grid gap-4">
    <!-- Step Cards -->
    <div v-for="(step, index) in steps" :key="step.id"
      class="bg-white rounded-3 p-4 position-relative border table-border-color border-light rounded-lg"
      :class="{ 'unsaved-changes': step.hasUnsavedChanges }">
      <div class="d-flex justify-content-between align-items-center mb-4 text-xxs">
        <div class="d-flex align-items-center">
          <div class="step-number text-xxs">{{ index + 1 }}</div>
          <div class="fs-6 fw-semibold text-dark ms-2 text-xs">{{ step.title }}</div>
        </div>
        <div class="d-flex gap-2">
          <button class="d-none btn btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark"
            @click="editStep(step.id)">Edit</button>
          <button class="d-none btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark"
            @click="delete_step(step.id)">Delete</button>
        </div>
      </div>

      <div class="mt-3">
        <div class="row g-3 align-items-end">
          <div class="col">
            <label class="form-label text-xs text-start text-dark">Step Name</label>
            <input type="text" class="form-control text-xxs text-start rounded-small shadow-sm" v-model="step.name"
              @input="mark_as_unsaved(step)" placeholder="Enter step name">
          </div>

          <div class="col">
            <label class="form-label text-xs text-start text-dark">Target Phase</label>
            <select class="form-select text-xxs text-start rounded-small shadow-sm" v-model="step.target_phase"
              @change="on_target_phase_change(step)">
              <option v-for="target in target_phases" :key="target.phase" :value="target.phase">
                {{ target.phase }}
              </option>
            </select>
          </div>

            <div class="col">
              <label class="form-label text-xs text-start text-dark">Trigger Status</label>
              <select
                class="form-select text-xxs text-start rounded-small shadow-sm"
                :value="step.trigger_status"
                @change="on_trigger_status_change($event, step)"
              >
                <option
                  v-for="status in get_trigger_statuses(step)"
                  :key="status.id"
                  :value="status.id"
                >
                  {{ status.formatted_status || status.status_name }}
                </option>
              </select>
            </div>
        </div>
      </div>

      <div class="mt-3">
        <div class="row g-3 align-items-start ">

          <!-- Card for Step Type -->
          <div class="col">
            <div class="card shadow-sm rounded-3 p-3 h-100  bg-light rounded-lg border border-2 border-light-subtle">
              <label class="form-label text-xs text-start text-dark mb-2">Step Type:</label>

              <div class="d-flex gap-3 flex-wrap">
                <div class="form-check">
                  <input checked class="form-check-input" type="radio" id="onceOff" value="once_off"
                    v-model="step.type">
                  <label class="form-check-label text-xxs text-dark" for="onceOff">
                    Once-off
                  </label>
                </div>

                <div class="form-check">
                  <input class="form-check-input" type="radio" id="recurring" value="recurring" v-model="step.type">
                  <label class="form-check-label text-xxs text-dark" for="recurring">
                    Recurring
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Recurring Fields -->
          <div class="col-12 mt-3" v-if="step.type === 'recurring'">
            <div class="card shadow-sm rounded-3 p-3 h-100 bg-light rounded-lg border border-2 border-light-subtle">
              <label class="form-label text-xs text-start text-dark mb-2">Recurring Interval</label>

              <select class="form-select text-xxs text-start rounded-small shadow-sm" v-model="step.frequency"
                @change="mark_as_unsaved(step)">
                <option disabled value="">Select interval</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      <div class="col-12 mt-3">
        <div class="card shadow-sm rounded-3 p-3 bg-light rounded-lg border border-2 border-light-subtle">
          <label class="form-label text-xs text-dark mb-2">
            Minimum Payment Required to Proceed
          </label>

          <!-- Radio buttons to select type -->
          <div class="d-flex gap-3 flex-wrap mb-3">
            <div class="form-check">
              <input class="form-check-input" type="radio" id="minPaymentPercentage" value="percentage"
                v-model="step.min_payment_type">
              <label class="form-check-label text-xxs text-dark" for="minPaymentPercentage">
                Percentage (%)
              </label>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="radio" id="minPaymentAmount" value="amount"
                v-model="step.min_payment_type">
              <label class="form-check-label text-xxs text-dark" for="minPaymentAmount">
                Exact Amount (R)
              </label>
            </div>
          </div>

          <!-- Conditional input -->
          <div v-if="step.min_payment_type === 'percentage'">
            <input type="number" min="0" max="100" class="form-control text-xxs rounded-small shadow-sm"
              v-model="step.min_payment_value" placeholder="Enter % e.g. 50">
            <small class="text-xxs text-muted">Customer must pay at least this % to move to next step.</small>
          </div>

          <div v-else>
            <input type="number" min="0" class="form-control text-xxs rounded-small shadow-sm"
              v-model="step.min_payment_value" placeholder="Enter amount e.g. 5000">
            <small class="text-xxs text-muted">Customer must pay at least this exact amount to move to next
              step.</small>
          </div>
        </div>
      </div>


      <div class="step-content mt-3">

        <div class="form-group d-none">
          <label>Invoice Template</label>
          <select class="form-select text-xxs rounded-small p-2 shadow-sm" v-model="step.template"
            @change="mark_as_unsaved(step)">
            <option value="standard">Standard Invoice</option>
            <option value="milestone">Milestone Invoice</option>
            <option value="recurring">Recurring Invoice</option>
            <option value="reminder">Reminder Invoice</option>
            <option value="final-notice">Final Notice</option>
          </select>
        </div>

        <div class="form-group d-none">
          <label>Priority</label>
          <select class="form-select text-xxs rounded-small p-2 shadow-sm" v-model="step.priority"
            @change="mark_as_unsaved(step)">
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>



        <!-- Invoice Items Section -->
        <div class="col-12 mt-4 p-4 bg-light rounded-lg border border-2 border-light-subtle">
          <div class="items-header">
            <p class="text-xs fw-bold ">Invoice Items</p>
            <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              @click="add_invoice_item(step)">Add Item</button>
          </div>

          <div v-if="step.items.length === 0" class="empty-items">
            <p class="text-xs text-muted">No items configured for this step.</p>
            <p class="text-xs text-muted">Click "Add Item" to define what should be included in invoices.</p>
          </div>

          <table v-else class="table-responsive w-100 table table-hover mt-3">
            <thead>
              <tr>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Item</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Quantity</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Price</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Total</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, itemIndex) in step.items" :key="itemIndex">
                <td class="text-xxs text-start">
                  <select class="w-100 p-2 border rounded-1" v-model="item.selectedItemId"
                    @change="update_selected_item(step, item)">
                    <option value="">Select item</option>
                    <option v-for="service in services" :key="service.id" :value="service.id">
                      {{ service.name }}
                    </option>
                  </select>
                </td>

                  <td class="text-xxs text-start">
                    <input
                      type="number"
                      class="w-100 p-2 border rounded-1"
                      v-model.number="item.quantity"
                      @input="mark_as_unsaved(step)"
                      min="0"
                      step="0.01"
                    >
                  </td>
                  <td class="text-xxs text-start">
                    <input
                      type="number"
                      class="w-100 p-2 border rounded-1 text-xxs text-start"
                      v-model.number="item.unitPrice"
                      @change="mark_as_unsaved(step)"
                      min="0"
                      step="0.01"
                      disabled
                    >
                  </td>
                  <td>
                    <input
                        type="text"
                        class="w-100 p-2 border rounded-1 text-xxs text-start"
                        :value="format_currency(item.quantity * item.unitPrice)"
                        disabled
                    >
                  </td>
                  <td class="text-xxs text-start">
                    <button
                     class="btn btn-primary-dark btn-sm rounded-small edit-btn text-xxs shadow text-dark"
                      @click="remove_invoice_item(step, itemIndex)"
                    >
                      Remove
                    </button>
                  </td>
                </tr>
                <tr class="total-row">
                  <td colspan="4"  class="text-end  tpe-4">
                    Total Amount:
                  </td>
                  <td>
                    <span class="item-calculation">
                      {{ format_currency(calculate_step_total(step)) }}
                    </span>
                  </td>
                  <td colspan="2"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Add New Step Button -->
      <div class="add-step-btn mb-5" @click="add_new_step">
        Add New Invoice Step
      </div>
    </div>
  </div>
